<template>
<div >
    <el-card style="width:100%;height: auto;margin-top: 1%;">
        <div slot="header" class="clearfix" style="display: inline-block;height: 100%;">
            <span>Major depressive disorder-related Original data</span><br/>
        </div>
        <!-- <el-tree :data="original_data" :props="defaultProps" @node-click="handleNodeClick"  default-expand-all></el-tree> -->
        <el-collapse v-model="activeCollapse" >
            <el-collapse-item title="Gene expression" name="geneExpression">
                <ul>
                    <li> Samples of human blood:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_geneExpression_blood.zip">MDDOmics_MDDori_geneExpression_blood.zip</a> (7 datasets, 3.31Gb)</li>
                    <li> Samples of human brain tissue:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_geneExpression_brain.zip">MDDOmics_MDDori_geneExpression_brain.zip</a> (19 datasets, 2.82Gb)</li>
                    <li> Samples of MDD patients with other disorders:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_geneExpression_differentDisorders.zip">MDDOmics_MDDori_geneExpression_differentDisorders.zip</a> (10 datasets, 8.36Gb)</li>
                    <li> Single cell datasets:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_geneExpression_singleCell.zip">MDDOmics_MDDori_geneExpression_singleCell.zip</a> (3 datasets, 11.5Gb)</li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="non-conding RNA" name="ncRNA">
                <ul>
                    <li> circRNA datasets:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_circRNA.zip">MDDOmics_MDDori_circRNA.zip</a> (2 datasets, 313Mb)</li>
                    <li> lncRNA datasets:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_lncRNA.zip">MDDOmics_MDDori_lncRNA.zip</a> (3 datasets, 0.98Gb)</li>
                    <li> miRNA datasets:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_miRNA.zip">MDDOmics_MDDori_miRNA.zip</a> (6 datasets, 375Mb)</li>
                    <li> snoRNA datasets:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_snoRNA.zip">MDDOmics_MDDori_snoRNA.zip</a> (2 datasets, 490Kb)</li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="DNA methylation" name="DNAMethylation">
                <ul>
                    <li> Samples of human blood:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_methylation_blood.zip">MDDOmics_MDDori_methylation_blood.zip</a> (5 datasets, 10.8Gb)</li>
                    <li> Samples of human brain tissue:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_methylation_brain.zip">MDDOmics_MDDori_methylation_brain.zip</a> (1 dataset, 806Mb)</li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="GWAS" name="gwas">
                <ul>
                    <li>Datasets from Psychiatric Genomics Consortium(PGC,<a href="https://pgc.unc.edu/for-researchers/download-results/">https://pgc.unc.edu/for-researchers/download-results/</a>)
                        <!-- :</br><a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_GWAS_PGC.zip">MDDOmics_MDDori_GWAS_PGC.zip</a>  -->
                        (6 datasets, ~2.61Gb)</li>
                    <li>Datasets from CONVERGE(<a href="http://gigadb.org/dataset/100155">http://gigadb.org/dataset/100155</a>):<br/>
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_GWAS_CONVERGE.zip">MDDOmics_MDDori_GWAS_CONVERGE.zip</a> (1 dataset, 404Mb)</li>
                    <li>Datasets from iPSYCH(<a href="https://ipsych.dk/en/research/downloads/">https://ipsych.dk/en/research/downloads/</a>)
                        <!-- :<br/><a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_GWAS_iPSYCH.zip ">MDDOmics_MDDori_GWAS_iPSYCH.zip</a>  -->
                        (3 datasets, ~540Mb)</li>
                    <li>Datasets from Nagel M et al.(<a href="https://ctg.cncr.nl/software/summary_statistics">https://ctg.cncr.nl/software/summary_statistics</a>, pmid:<a href="https://www.nature.com/articles/s41588-018-0151-7">29942085</a>):<br/>
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_GWAS_Nagel M et al.zip">MDDOmics_MDDori_GWAS_Nagel M et al.zip</a> (1 datasets, 1.3Gb)</li>
                </ul>
            </el-collapse-item>
          
            <el-collapse-item title="Protein" name="protein">
                <ul>
                    <li><a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=PXD023009.zip">PXD023009</a>(8.01Gb): Plasma non-targeted peptidomics discovers potential biomarkers for major depressive disorder
                    </li>
                    <li><a href="https://download.iprox.cn/IPX0004437000/IPX0004437001/HFX-DIA.rar">PXD033947</a>(129Gb): The chemokine CCL5 and CXCL4 as plasma biomarkers for differential diagnosis of bipolar and major depressive disorder
                    </li>
                    <li><a href="https://download.iprox.cn/IPX0007599000/IPX0007599001/23050910_LLY_DIA_tims.rar">PXD047302</a>(299Gb): Serum proteomic biomarker investigation of vascular depression using data-independent acquisition (DIA): a pilot study
                    </li>
                    <li><a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=PXD028947.zip">PXD028947</a>(12Gb): iTRAQ paroxetine response in major depressive disorder
                    </li>
                    <li><a href="https://ftp.pride.ebi.ac.uk/pride/data/archive/2023/03/PXD034030">PXD034030</a>(1.02T): Plasma proteomic signature of major depressive episode in the elderly
                    </li>
                    <li><a href="https://ftp.pride.ebi.ac.uk/pride/data/archive/2022/02/PXD028841/">PXD028841</a>(215.4Gb): Quantitative proteomic analysis of plasma in major mental disorders
                    </li>
                    <li><a href="https://ftp.pride.ebi.ac.uk/pride/data/archive/2020/11/PXD017211">PXD017211</a>(366.5Gb): Human plasma LC-MSMS for predicting drug-response progonosis in depressed patients at 0, 1, 4 and 10 visiting weeks
                    </li>
                    <li><a href="https://www.iprox.cn/page/ProjectFileList.html?projectId=IPX0002680000">PXD025608</a>(212.2G): Identification of early candidate urine biomarkers for measure Escitalopram treatment response from major depressive disorder
                    </li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="Metabolite" name="metabolite">
                <ul>
                    <li> Samples of human blood:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_metabolite_blood.zip">MDDOmics_MDDori_metabolite_blood.zip</a> (4 datasets, 6.74Gb)</li>
                    <li> Samples of human brain tissue:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_metabolite_brain.zip">MDDOmics_MDDori_metabolite_brain.zip</a> (1 datasets, 1.81Gb)</li>
                    <li> Samples of human excreta:
                    <a href="https://www.csuligroup.com/depression_analysis/download/original?file_name=MDDOmics_MDDori_metabolite_excreta.zip">MDDOmics_MDDori_metabolite_excreta.zip</a> (2 datasets, 4.41Gb)</li>
                </ul>
            </el-collapse-item>
            </el-collapse>
    </el-card>
    <!-- multi-omics data -->
    <el-card style="width:100%;height: auto;margin-top: 2%;">
        <div slot="header" class="clearfix" style="display: inline-block;height: 100%">
            <span>Omics data</span>
        </div>
        <template>
            <el-table
            :data="tableData"
            style="width: 100%;" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column
                prop="head"
                label="Omics/Disease"
                width="150">
            </el-table-column>
            <el-table-column
                prop="MDD"
                label="Major depressive disorder">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="download('browse',scope.row.MDD)"> {{scope.row.MDD}}  </a>
                </template>
            </el-table-column>
            <el-table-column
                prop="BD"
                label="Bipolar disorder">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="download('browse',scope.row.BD)"> {{scope.row.BD}}  </a>
                </template>
            </el-table-column>
            <el-table-column
                prop="SZ"
                label="Schizophrenia">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="download('browse',scope.row.SZ)"> {{scope.row.SZ}}  </a>
                </template>
            </el-table-column>
            <el-table-column
                prop="AX"
                label="Anxiety disorder">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="download('browse',scope.row.AX)"> {{scope.row.AX}}  </a>
                </template>
            </el-table-column>
            </el-table>
        </template>
            
    </el-card> 
    <el-card style="width:100%;height: auto;margin-top: 2%;">
        <div slot="header" class="clearfix" style="display: inline-block;height: 100%">
            <span>Analysis data</span><br/>
        </div>
        <el-table
        :data="tableAnalysisData"
        style="width: 100%;" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column
                label="Enrichment analysis">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="download('analysis',scope.row.first)"> {{scope.row.first}}  </a>
                </template>
            </el-table-column>
            <el-table-column
                label="Differential gene analysis">
                <template slot-scope="scope">
                    <a :href="'./file/' + scope.row.second" :download= "scope.row.second"> {{scope.row.second}}  </a>
                </template>
            </el-table-column>
            <el-table-column
                label="Prediction Data">
                <template slot-scope="scope">
                    <a :href="'./file/' + scope.row.third" :download= "scope.row.third"> {{scope.row.third}}  </a>
                </template>
            </el-table-column>
            </el-table>
    </el-card> 
</div>
</template>

<script>
import{Loading}from'element-ui';

export default{
    data(){
        return{
            activeCollapse:['geneExpression',"DNAMethylation","gwas","ncRNA","protein","metabolite"],
            loadingInstance:null,
            percentage:0,
            tableData: [{
                head: 'SNP',
                MDD: 'MDDOmics_MDD_snp.xlsx',
                BD: 'MDDOmics_BD_snp.xlsx',
                SZ:'MDDOmics_SZ_snp.xlsx',
                AX:'MDDOmics_AX_snp.xlsx',
            }, {
                head: 'Gene',
                MDD: 'MDDOmics_MDD_gene.xlsx',
                BD: 'MDDOmics_BD_gene.xlsx',
                SZ:'MDDOmics_SZ_gene.xlsx',
                AX:'MDDOmics_AX_gene.xlsx',
            }, {
                head: 'ncRNA',
                MDD: 'MDDOmics_MDD_rna.xlsx',
                BD: 'MDDOmics_BD_rna.xlsx',
                SZ:'MDDOmics_SZ_rna.xlsx',
                AX:'MDDOmics_AX_rna.xlsx',
            },{
                head: 'Methylation',
                MDD: 'MDDOmics_MDD_methylation.xlsx',
                BD: '',
                SZ:'MDDOmics_SZ_methylation.xlsx',
                AX:'',
            },{
                head: 'Metabolite',
                MDD: 'MDDOmics_MDD_metabolite.xlsx',
                BD: '',
                SZ:'',
                AX:'',
            },{
                head: 'Protein',
                MDD: 'MDDOmics_MDD_protein.xlsx',
                BD: '',
                SZ:'',
                AX:'',
            },{
                head: 'multi-omics',
                MDD: 'MDDOmics_MDD.zip',
                BD: 'MDDOmics_BD.zip',
                SZ:'MDDOmics_SZ.zip',
                AX:'MDDOmics_AX.zip',
            }],
            tableAnalysisData: [{
                first: 'MDDOmics_Conventional_enrichment.xlsx',
                second: 'MDDOmics_DEG.xlsx',
                third:'MDDOmics_prediction_gene.xlsx',
            }, {
                first: 'MDDOmics_WEAT_enrichment.xlsx',
                second: 'MDDOmics_DMR.xlsx',
                third:'MDDOmics_prediction_lncRNA.xlsx',
            }, {
                first: '',
                second: 'MDDOmics_DMP_GSE201287.xlsx',
                third:'MDDOmics_prediction_miRNA.xlsx',
            }, {
                first: '',
                second: 'MDDOmics_DMP_GSE88890.xlsx',
                third:'',
            }],            
        }
    },
    methods:{
        download(type,file){
            this.percentage=0;
            var loadingInstance = Loading.service({
                text:"This may take a few seconds. Please wait. "
            });
            if(type=='browse'){
                if (file.endsWith('.zip')) {
                    const link = document.createElement('a');
                    link.href = './file/' + file;
                    link.download = file;
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    loadingInstance.close();  
                return
            }
                var disease=file.split('_')[1]
                var omics=file.split('_')[2].split('\.')[0]
                this.axios.get(this.GLOBAL.rootAddress+'download/browse',
                 { 
                    params: { 
                        'disease': disease,
                        'type': omics,
                    },
                    responseType: 'blob',
                 }).then((response) => {
                    let url = window.URL.createObjectURL(response.data);
                    let link = document.createElement('a');
                    link.href = url;
                    link.download = file;
                    document.body.appendChild(link);
                    link.click();
                    link.remove(); 
                    window.URL.revokeObjectURL(link.href);
                    loadingInstance.close();  
                })
            }else {
               this.axios.get(this.GLOBAL.rootAddress+'download/analysis',
                {   
                    params: { 
                        'type': file,
                    },
                    responseType: 'blob',
                    onDownloadProgress:(progressEvent)=>{
                        // console.log('进度事件', progressEvent);
                        this.percentage = progressEvent.loaded;
                        loadingInstance.setText(`Have downloaded: ${this.percentage}byte`)
                        //接收进度为99%的时候需要留一点前端编译的时间
                    }   
                }).then((response) => {
                    // console.log(this.percentage)
                    let url = window.URL.createObjectURL(response.data);
                    let link = document.createElement('a');
                    link.href = url;
                    link.download = file;
                    document.body.appendChild(link);
                    link.click();
                    link.remove(); 
                    window.URL.revokeObjectURL(link.href);
                    loadingInstance.close();  
            })
            }
        },

        download_ori(file_name){
            this.axios.get(this.GLOBAL.rootAddress+'download/original',
            {
                params:{
                    'file_name':file_name

                },responseType:'blob'
            }).then((response)=>{
                console.log('success')
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file_name); // 或者从响应头中获取文件名
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => console.error('Download error:', error));
        },
    }
}
</script>

<style>

.el-loading-spinner .el-loading-text{
  color: #ff8000 !important;
}

.el-collapse-item__content{
    text-align:left;
    font-size:16px;
}
</style>


